/* eslint-disable max-len */

export const CHRISTMAS_DATES = [
  '12/25/2021',
  '12/25/2022',
  '12/25/2023',
  '12/25/2024',
  '12/25/2025',
  '12/25/2026',
  '12/25/2027',
  '12/25/2028',
  '12/25/2029',
  '12/25/2030',
  '12/25/2031'
];

export const THANKSGIVING_DATES = [
  '11/25/2021',
  '11/24/2022',
  '11/23/2023',
  '11/28/2024',
  '11/27/2025',
  '11/26/2026',
  '11/25/2027',
  '11/23/2028',
  '11/22/2029',
  '11/28/2030',
  '11/27/2031'
];

export const DEFAULT_OPEN_CLOSE_HOURS = { open: '6:00', close: '21:00' };

export const DEFAULT_STORE_HOURS = {
  monday: DEFAULT_OPEN_CLOSE_HOURS,
  tuesday: DEFAULT_OPEN_CLOSE_HOURS,
  wednesday: DEFAULT_OPEN_CLOSE_HOURS,
  thursday: DEFAULT_OPEN_CLOSE_HOURS,
  friday: DEFAULT_OPEN_CLOSE_HOURS,
  saturday: DEFAULT_OPEN_CLOSE_HOURS,
  sunday: { open: '8:00', close: '20:00' }
};

export const AVERAGE_HOURS_GAP_RENTAL_TO_STORE = 2;
export const RESERVATION_BUFFERS = {
  pickTime: 5,

  // 4 hours after opening
  afterOpen: 4,

  // 2 hours before closing
  beforeClose: 2,

  // hours before closing to make a 6AM reservation
  openingSlotAvailable: 4,

  // minimum reservation duration
  minimunDuration: 1
};

export const ACCOUNT_FOR_PHARMACY_HOURS = false;

// API consts
export const RESERVATIONS_AVAILABILITY_URL = '/product-information/rental/reservations/availability';
export const RESERVATIONS_MODIFY_AVAILABILITY_URL = '/product-information/rental/reservations/modifyAvailability';
export const RESERVATIONS_FDAV4_URL = '/product-information/rental/tool/availability';
export const RENTAL_PRICING_URL = '/product-information/rental/inventory/pricing';
export const RESERVATION_CANCEL_URL = '/product-information/rental/reservations/cancel';
export const RESERVATION_CREATE_URL = '/product-information/rental/reservations/create';
export const RESERVATION_LOOKUP_URL = '/product-information/rental/reservations';
export const RESERVATION_UPDATE_URL = '/product-information/rental/reservations/{reservationId}/modify_reservation_time';

// vantage
export const MAX_VANTAGE_RETRIES = 2;

// StoreSearchServices
export const STORE_SEARCH_RADIUS = 200;
export const STORES_LIMIT = 30;

// TRIO list batch size
export const DEFAULT_BATCH_SIZE = 5;

// ItemIds for examples
export const TOOL_ITEMID = '316821412'; // Carpet Cleaner
export const VEHICLE_ITEMID = '316821410'; // Load-N-Go Van
export const LARGE_EQUIP_ITEMID = '316821721'; // Mini Excavator
export const SCISSOR_LIFT_ITEMID = '316821928'; // Scissor Lift
export const MINI_SKID_ITEMID = '316822124'; // Mini Skid Steer
export const BOOM_LIFT_ITEMID = '316821508'; // Boom Lift
export const BLACKLISTED_ITEMID = '316821727'; // Material Lift
export const DELIVERY_ONLY_LARGE_EQUIP_ITEMID = '316822174';

// for Moment date parsing
export const MILITARY_DATE_TIME = 'MM/DD/YYYY H:mm';
export const STANDARD_DATE_TIME = 'MM/DD/YYYY h:mm a';

// categories
export const VEHICLE_CATEGORIES = ['45', '65', '95'];
export const LARGE_EQUIPMENT_CATEGORIES = ['33'];

// Choose Dayas and Times Form
export const DELIVERY_INPUT_NAMES = {
  DELIVERY_DATE: 'deliveryDate',
  DELIVERY_TIME: 'deliveryTime',
  PICKUP_DATE: 'pickupDate',
  PICKUP_TIME: 'pickupTime',
};